import { TravellerActionGroupAction } from 'api/traveller-actions/requests';
import { TravellerJourneyActionDetailed } from 'api/types';

export const isActionError = (
  action?: TravellerJourneyActionDetailed | TravellerActionGroupAction
) => {
  if (!action) {
    return false;
  }
  return action.status !== 'completed' && !!action.result && !!action.result.dateFailed;
};
